import React from 'react'; 
import { Link } from 'react-router-dom';
import '../../../CSS/home_footer.scss';
import HomeFooterContent from '../Home/HomeFooterContent';

const HomeFooter = ({data})=> { 
  return (
    <div className="home-footer">
        <div className="home-footer-overlay">
        <div className="footer-content">
            <HomeFooterContent data = {data}/>
        </div>
        <div className="footer">
            <div className="container-fluid">
                <div className="row footer-contents">
                    <div className="col col-md-2 col-lg-2 col-sm-2">
                        <h5>
                            <Link className="home-footer-link" to="/main/about">KNOW ME</Link>
                        </h5>
                    </div>
                    <div className="col col-md-2 col-lg-2 col-sm-2">
                        <h5>
                            <Link className="home-footer-link" to="/main/contact">GET IN TOUCH</Link>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>

  );
}

export default HomeFooter; 